<template>
	<header-block v-if="customer" title="🏆 Leader Board" bgcolor="white"></header-block>
	<CustomerLoadWait :customer="points" />
	<transition>
		<div v-if="points" class="leaderboard-container">
			<div class="leaderboard">
				<div class="leaderboard-list">
					<div 
						v-for="(entry, index) in leaderboardEntries" 
						:key="index"
						class="leaderboard-entry"
						:class="{
							'user-entry': entry.isUser,
							'blurred': !entry.isUser,
							'top-position': index < 3 && !entry.isUser
						}"
					>
						<div class="position">
							<span class="position-number">{{ entry.position }}</span>
							<span v-if="index === 0" class="trophy">🥇</span>
							<span v-else-if="index === 1 && !entry.isUser" class="trophy">🥈</span>
							<span v-else-if="index === 2 && !entry.isUser" class="trophy">🥉</span>
						</div>
						<div class="player-info">
							<div class="player-name">{{ entry.name }}</div>
							<div class="player-points">{{ entry.points }} points</div>
						</div>
						<div v-if="entry.isUser" class="user-badge">You</div>
					</div>
				</div>
				<div class="user-stats">
					<p>Your current position: <strong>#{{ points.position }}</strong></p>
					<p>Your points: <strong>{{ points.points }}</strong></p>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import Helpers from '../mixins/Helpers';

export default {
	mixins: [Services, Helpers],
	components: {CustomerLoadWait, HeaderBlock},
	data() {
		return {
			leaderboardEntries: null
		}
	},
	methods: {
		onLoad: async function() {
			this._getCustomer(() => {
				this._getPoints(() => {
					this.generateLeaderboard();
				});
			});
		},
		generateLeaderboard() {
			const userPosition = this.points.position;
			const userPoints = this.points.points;
			const fictionalNames = [
				'Alex Thompson', 'Sarah Chen', 'Mike Rodriguez', 'Emma Wilson',
				'David Park', 'Lisa Johnson', 'Ryan Kumar', 'Sophia Davis',
				'James Miller', 'Olivia Brown', 'Daniel Lee', 'Isabella Garcia',
				'Matthew Anderson', 'Ava Martinez', 'Christopher Taylor',
				'Mia Jackson', 'Andrew White', 'Charlotte Harris', 'Joshua Clark',
				'Amelia Lewis', 'Anthony Young', 'Harper King', 'Nicholas Scott',
				'Evelyn Green', 'Tyler Adams', 'Abigail Baker', 'Jacob Hill',
				'Emily Nelson', 'William Carter', 'Madison Mitchell', 'Ethan Perez',
				'Elizabeth Roberts', 'Alexander Turner', 'Sofia Phillips',
				'Benjamin Campbell', 'Ella Parker', 'Samuel Evans', 'Scarlett Edwards',
				'Logan Collins', 'Chloe Stewart', 'Lucas Sanchez', 'Lily Morris',
				'Jackson Rogers', 'Grace Reed', 'Aiden Cook', 'Zoe Morgan',
				'Elijah Bell', 'Hannah Murphy', 'Gabriel Bailey', 'Nora Rivera',
				'Carter Cooper', 'Lillian Richardson', 'Owen Cox'
			];
			const entries = [];
			const totalEntries = Math.max(10, userPosition + 5); // Show at least 10 entries
			for (let i = 1; i <= totalEntries; i++) {
				if (i === userPosition) {
					// User entry
					entries.push({
						position: i,
						name: this.customer ? (this.customer.person.firstName + ' ' + this.customer.person.lastName) : 'You',
						points: userPoints,
						isUser: true
					});
				} else {
					// Fictional entry
					const nameIndex = (i - 1) % fictionalNames.length;
					const basePoints = userPoints + (userPosition - i) * Math.floor(Math.random() * 50 + 10);
					const points = Math.max(0, basePoints + Math.floor(Math.random() * 20 - 10));
					entries.push({
						position: i,
						name: fictionalNames[nameIndex],
						points: points,
						isUser: false
					});
				}
			}
			this.leaderboardEntries = entries;
		}
	},
	mounted: function () {
		this.onLoad();
	},
}
</script>

<style scoped>
.leaderboard-container {
	font-family: "Press Start 2P", system-ui;
	font-weight: 400;
	font-style: normal;
	padding: 20px;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	min-height: 100vh;
	margin-right: -30px;
	margin-left: -30px;
	margin-top: -20px;
}

.leaderboard {

}

.leaderboard-list {
	margin-bottom: 30px;
	font-family: "Press Start 2P", system-ui !important;
	font-weight: 400;
	font-style: normal;
}

.leaderboard-entry {
	display: flex;
	align-items: center;
	padding: 15px 20px;
	margin-bottom: 10px;
	background: #f8f9fa;
	border-radius: 12px;
	border: 2px solid transparent;
	transition: all 0.3s ease;
	position: relative;
	font-family: "Press Start 2P", system-ui !important;
	font-weight: 400;
	font-style: normal;
}

.leaderboard-entry.user-entry {
	background: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
	border: 2px solid #ff8a65;
	box-shadow: 0 8px 25px rgba(255, 138, 101, 0.3);
	transform: scale(1.02);
}

.leaderboard-entry.blurred {
	filter: blur(3px);
	opacity: 0.7;
	background: #e9ecef;
}

.leaderboard-entry.top-position {
	background: linear-gradient(135deg, #ffd89b 0%, #19547b 100%);
	color: white;
}

.leaderboard-entry.top-position.blurred {
	filter: blur(2px);
	opacity: 0.6;
}

.position {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	background: #007bff;
	color: white;
	border-radius: 50%;
	font-weight: bold;
	font-size: 18px;
	margin-right: 20px;
	position: relative;
}

.user-entry .position {
	background: #ff6b35;
}

.top-position .position {
	background: rgba(255, 255, 255, 0.2);
}

.position-number {
	font-size: 16px;
	font-family: "Press Start 2P", system-ui !important;
	font-weight: 400;
	font-style: normal;
}

.trophy {
	position: absolute;
	top: -5px;
	right: -5px;
	font-size: 20px;
}

.player-info {
	flex: 1;
}

.player-name {
	font-weight: bold;
	font-size: 16px;
	margin-bottom: 5px;
	color: #333;
	font-family: "Press Start 2P", system-ui;
	font-weight: 400;
	font-style: normal;
}

.top-position .player-name {
	color: white;
}

.player-points {
	font-size: 14px;
	color: #666;
	font-family: "Press Start 2P", system-ui;
	font-weight: 400;
	font-style: normal;
}

.top-position .player-points {
	color: rgba(255, 255, 255, 0.9);
}

.user-badge {
	background: #28a745;
	color: white;
	padding: 8px 16px;
	border-radius: 20px;
	font-size: 12px;
	font-weight: bold;
	text-transform: uppercase;
	font-family: "Press Start 2P", system-ui;
	font-weight: 400;
	font-style: normal;
}

.user-stats {
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
	padding: 20px;
	border-radius: 12px;
	text-align: center;
}

.user-stats p {
	margin: 10px 0;
	font-size: 16px;
}

.user-stats strong {
	font-size: 20px;
}

/* Animation for the transition */
.v-enter-active, .v-leave-active {
	transition: all 0.5s ease;
}

.v-enter-from, .v-leave-to {
	opacity: 0;
	transform: translateY(30px);
}

/* Responsive design */
@media (max-width: 768px) {
	.leaderboard-container {
		padding: 10px;
	}
	
	.leaderboard {
		padding: 20px;
	}
	
	.leaderboard-entry {
		padding: 12px 15px;
	}
	
	.position {
		width: 50px;
		height: 50px;
		margin-right: 15px;
	}
	
	.player-name {
		font-size: 14px;
	}
	
	.player-points {
		font-size: 12px;
	}
}
</style>
